import { Dispatch, SetStateAction, useEffect, useReducer } from 'react';
import { useNavigate } from 'react-router-dom';

function init(initIndex: number) {
  return { activeIndex: initIndex };
}

function reducer(
  state: {
    activeIndex: number;
  },
  activeIndex: number
) {
  return { activeIndex };
}

const TabGroup = ({
  isHorizontal = false,
  otherNode,
  tabsClass = 'tabs overflow-hidden cyfi-tab',
  tabClass = 'tab',
  initIndex = 0,
  labels,
  childrens,
  navigateUrl,
  otherClass,
  setFocusTab,
  showCurrentTab = true,
  onClickPreFunction,
}: {
  isHorizontal?: boolean;
  otherNode?: React.ReactNode;
  tabsClass?: string;
  tabClass?: string;
  initIndex?: number;
  labels: string[] | React.ReactNode[];
  childrens: React.ReactNode[];
  navigateUrl?: string[];
  otherClass?: string;
  setFocusTab?: Dispatch<SetStateAction<number>>;
  showCurrentTab?: boolean;
  onClickPreFunction?: (tab: number) => Promise<boolean>;
}) => {
  const [state, dispatch] = useReducer(reducer, initIndex, init);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(initIndex);
    setFocusTab && setFocusTab(initIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initIndex]);

  return (
    <div className={isHorizontal ? 'flex space-x-4' : 'flex flex-col w-full h-full'}>
      <div className={(isHorizontal ? 'space-y-2 ' : 'flex w-full px-5 items-center relative justify-end ') + `${otherClass}`}>
        {otherNode}
        <div className={tabsClass}>
          {labels.map((label, index) => (
            <div
              className={tabClass + (index === state.activeIndex ? ' tab-active' : '')}
              onClick={async () => {
                if (onClickPreFunction) {
                  const result = await onClickPreFunction(state.activeIndex);
                  if (result === false) {
                    return false;
                  }
                }
                navigateUrl && navigate(`${navigateUrl[index]}`);
                dispatch(index);
                setFocusTab && setFocusTab(index);
              }}
              key={index}
            >
              {label}
            </div>
          ))}
        </div>
      </div>
      {showCurrentTab === true ? (
        <div className={isHorizontal ? 'flex-1' : 'overflow-y-auto h-full'}>{childrens.find((children, index) => index === state.activeIndex)}</div>
      ) : (
        <div className={isHorizontal ? 'flex-1' : 'overflow-y-auto h-full max-h-[720px] webkit'}>
          {childrens.map((children, index) => (
            <div key={index} style={{ display: index === state.activeIndex ? 'block' : 'none' }}>
              {children}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TabGroup;
